import { LoginValues, SubmitStatus } from '@/pages/unauthenticated/Login';
import { getErrorCodes } from '@/utils/utilities';
import httpClient from './httpClient';
import { Client } from '@/types/users';
import { RegisterForm } from '@/pages/unauthenticated/Register';

type TokenResponse = {
	token: string;
	refreshToken: string;
};

abstract class UnauthenticatedApi {
	static login = async ({ email, password }: LoginValues) => {
		const response = await httpClient.post<TokenResponse>('auth/login', {
			email,
			password,
		});

		return response;
	};

	static register = async (form: Partial<RegisterForm>) => {
		const response = await httpClient.post<Client>('auth/register', form);

		return response.data;
	};

	static refreshToken = async (refreshToken: string) => {
		const response = await httpClient.post<TokenResponse>(
			'auth/refresh',
			{},
			{
				headers: {
					Authorization: `Bearer ${refreshToken}`,
				},
			}
		);

		return response;
	};

	static requestResetPassword = async (email: string) => {
		try {
			await httpClient.post('auth/forgot/password', {
				email,
				redirectUrl: `${import.meta.env.VITE_APP_URL}set-password`,
			});
			return SubmitStatus.SUCCESS;
		} catch (error) {
			const message = getErrorCodes(error);
			return { message };
		}
	};

	static resetPassword = async ({
		hash,
		password,
	}: {
		hash: string;
		password: string;
	}) => {
		await httpClient.post('auth/reset/password', {
			hash,
			password,
		});

		return 1;
	};

	static confirmAccount = async (hash: string) => {
		await httpClient.post('auth/email/confirm', {
			hash,
		});
	}

	static logout = async () => {
		await httpClient.post('auth/logout', {});
		return 1;
	};

	static confirmEmail = async (token: string) => {
		return httpClient.post('/auth/confirm-email', { token });
	};
}

export default UnauthenticatedApi;
